<template>
  <v-card :id="eleId">
    <v-card-title>
      {{ setting.title }}
      <v-spacer></v-spacer>
      <v-btn icon @click="cancelAction">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-layout row wrap>
        <template v-for="(field, index) in setting.fields">
          <v-flex
            :class="`${setting.fieldClass} p-l-10 p-r-10`"
            :key="index"
            v-if="displayByPayrollFrequency(field.fieldKey)"
          >
            <template v-if="field.controlType === 'spanWithText'">
              <span>{{ field.label }} : {{ assist.tool.fieldRender(current, field.template, field.format) }}</span>
            </template>
            <v-select
              v-else-if="field.controlType === 'select'"
              v-model="current[field.fieldKey]"
              :label="field.label"
              :items="field.fieldKey.includes('DayOfMonth') ? dayOfMonthOptions : field.items[field.fieldKey]"
              item-text="text"
              item-value="value"
              :disabled="field.disabled"
              @change="changeEventHandler"
              v-validate="'required|notEmpty'"
              data-vv-name="notEmpty"
              :error-messages="errors.first('notEmpty')"
              hide-details
            ></v-select>
            <v-select
              v-else-if="field.controlType === 'requestSelectItems'"
              v-model="current[field.fieldKey]"
              label="Return Code"
              :items="returnCodeArr"
              :disabled="field.disabled"
              @change="changeEventHandler"
              v-validate="'required|notEmpty'"
              data-vv-name="notEmpty"
              :error-messages="errors.first('notEmpty')"
              hide-details
            ></v-select>
            <arb-date-picker-menu
              v-else-if="field.controlType === 'date' && returnDataType === 'multiData'"
              v-model="current[field.fieldKey]"
              :label="field.label"
              :allowed="getFieldAllow(field, current)"
              :lessDate="getLessDate()"
              :notEmptyChanged="true"
              @change="changeEventHandler('nextPayrollDate')"
              v-validate="'required'"
              data-vv-name="notEmpty"
            ></arb-date-picker-menu>
            <arb-date-picker-menu
              v-else-if="field.controlType === 'date' && returnDataType !== 'multiData'"
              v-model="current[field.fieldKey]"
              :label="field.label"
              :allowed="getDateAllowed(field)"
              :lessDate="getLessDate()"
              :notEmptyChanged="true"
              @change="changeEventHandler"
              v-validate="'required'"
              data-vv-name="notEmpty"
            ></arb-date-picker-menu>
            <arb-date-picker-menu
              v-else-if="field.moreDate"
              v-model="current[field.fieldKey]"
              :label="field.label"
              :allowed="getDateAllowed(field)"
              :notEmptyChanged="true"
              :moreDate="current.firstDebitDate"
              @change="changeEventHandler"
              v-validate="'required'"
              data-vv-name="notEmpty"
            ></arb-date-picker-menu>
            <arb-checkbox-input
              v-else-if="field.fieldKey ==='interest' && interestDisplay"
              v-model="current[field.fieldKey]"
              :label="field.label"
              :prefix="field.format === 'currency' ? '$' : ''"
              @change="checkboxInputChangeEventHandler"
            ></arb-checkbox-input>
            <arb-checkbox-input
              v-else-if="field.fieldKey ==='principal' && isPrincipalDisplay"
              v-model="current[field.fieldKey]"
              :label="field.label"
              :prefix="field.format === 'currency' ? '$' : ''"
              @change="checkboxInputChangeEventHandler"
            ></arb-checkbox-input>
            <arb-checkbox-input
              v-else-if="field.controlType === 'checkbox-input' && (field.fieldKey === 'unpaidFee' || setting.value !== assist.dataType.PaymentScheduleAction.ASSIGNED_AMOUNT.value || !$route.path.includes('/post-origination/application/'))"
              v-model="current[field.fieldKey]"
              :disable="field.disabled"
              :label="field.label"
              :prefix="field.format === 'currency' ? '$' : ''"
              @change="checkboxInputChangeEventHandler"
            ></arb-checkbox-input>
            <v-text-field
              v-else-if="field.format === 'text'"
              v-model="current[field.fieldKey]"
              :label="field.label"
              :disabled="field.disabled"
              @focusout="changeEventHandler"
              v-validate="'required|notEmpty'"
              data-vv-name="notEmpty"
              :error-messages="errors.first('notEmpty')"
              hide-details
            ></v-text-field>
            <v-text-field
              v-else-if="field.couldEmpty"
              v-model="current[field.fieldKey]"
              :label="field.label"
              :disabled="field.disabled"
              @focusout="changeEventHandler"
              hide-details
            ></v-text-field>
            <v-text-field
              v-else-if="field.couldEmpty && field.format === 'currency'"
              prefix="$"
              v-model="current[field.fieldKey]"
              :label="field.label"
              :disabled="field.disabled"
              @focusout="changeEventHandler"
              v-validate="'currency'"
              data-vv-name="currency"
              :error-messages="errors.first('currency')"
              hide-details
            ></v-text-field>
            <v-text-field
              v-else-if="!field.couldEmpty && field.format === 'currency'"
              prefix="$"
              v-model="current[field.fieldKey]"
              :label="field.label"
              :disabled="field.disabled"
              @focusout="changeEventHandler"
              v-validate="'currency'"
              data-vv-name="currency"
              :error-messages="errors.first('currency')"
              hide-details
            ></v-text-field>
            <v-text-field
              v-else
              v-model="current[field.fieldKey]"
              :label="field.label"
              :disabled="field.disabled"
              @focusout="changeEventHandler('debitCount')"
              v-validate="'required|number'"
              data-vv-name="number"
              :error-messages="errors.first('number')"
              hide-details
            ></v-text-field>
          </v-flex>
        </template>
      </v-layout>
      <v-file-input
        v-if="setting.hasFile"
        v-model="file"
        label="File"
        show-size
        hide-details
      ></v-file-input>
      <v-divider class="m-t-30 m-b-0"></v-divider>
      <v-layout v-if="setting.value !== dataType.PaymentScheduleAction.CANCEL_CHANGE.value && hasSaveBtn" row wrap>
        <template v-if="returnDataType === 'multiData'">
          <v-flex class="lg4 p-l-10 p-r-10">
            <v-form data-vv-scope="form">
              <v-select
                v-model="authorizationType"
                label="Authorization Type"
                :items="typeItems"
                item-text="text"
                item-value="value"
                v-validate="'required'"
                data-vv-name="notEmpty"
                :error-messages="errors.first('form.notEmpty')"
                hide-details
              ></v-select>
              <div class="p-10">
                <p class="grey--text m-0"><v-icon color="warning">warning</v-icon> Please note that nothing will be saved if you do not select authorization type</p>
              </div>
            </v-form>
          </v-flex>
          <v-flex class="p-l-10 p-r-10">
            <v-textarea
              rows="3"
              label="Note"
              v-model="note"
              hide-details
            ></v-textarea>
          </v-flex>
        </template>
        <template v-else>
          <v-flex :class="`${setting.fieldClass} p-l-10 p-r-10`">
            <v-form data-vv-scope="form">
              <v-select
                v-model="authorizationType"
                label="Authorization Type"
                :items="typeItems"
                item-text="text"
                item-value="value"
                v-validate="'required'"
                data-vv-name="notEmpty"
                :error-messages="errors.first('form.notEmpty')"
                hide-details
              ></v-select>
            </v-form>
          </v-flex>
          <v-flex :class="`${setting.fieldClass} p-l-10 p-r-10`">
            <v-textarea
              rows="2"
              label="Note"
              v-model="note"
              hide-details
            ></v-textarea>
          </v-flex>
        </template>
      </v-layout>
      <arb-simple-table
        v-if="showTable && showPaymentScheduleTable && isShowRovoked === true"
        class="m-t-15 m-b-10"
        :header="tableSetting"
        :height="200"
        :desserts="current.newInstallments"
        color="white"
      ></arb-simple-table>
      <payment-schedule-table
        class="m-t-15 m-b-10"
        v-if="payOffInNTable && isAllocatePrincipalManuallyShow"
        :headers="tableSetting"
        :items="current.newInstallments"
      >
      </payment-schedule-table>
      <v-layout wrap  v-if="showTable && isShowRovoked === true">
        <v-flex lg4>
          Principal: {{  this.current.displayPrincipal ? assist.tool.formatCurrency(this.current.displayPrincipal) : '$0.00' }}
          <span :class="renderSpanColor(this.current.changePrincipal)">
            ({{ this.current.changePrincipal ? this.current.changePrincipal : 0 }})
          </span>
        </v-flex>
        <v-flex lg4>
          Interest: {{ this.current.displayInterest ? assist.tool.formatCurrency(this.current.displayInterest) : '$0.00' }}
          <span :class="renderSpanColor(this.current.changeInterest)">
            ({{ this.current.changeInterest ? this.current.changeInterest : 0 }})
          </span>
        </v-flex>
        <v-flex lg4>
          Amount: {{ this.current.displayAmount ? assist.tool.formatCurrency(this.current.displayAmount) : '$0.00' }}
          <span :class="renderSpanColor(this.current.changeAmount)">
            ({{ this.current.changeAmount ? this.current.changeAmount : 0 }})
          </span>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-btn v-if="isAllocatePrincipalManuallyShow" text @click="ManuallytableShow">Allocate Principal Manually</v-btn>
      <span class="text-red m-l-15" :class="error !== '' ? 'error-info' : ''">{{ error }}</span>
      <v-spacer></v-spacer>
      <v-btn v-if="hasSaveBtn && isShowRovoked === true" text @click="enterAction" :disabled="saveBtn">SAVE</v-btn>
      <v-btn text @click="enterAction" v-else>SAVE</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { DataType, Tool, Popup } from '@/util/index'
import { PPS_DIALOG_LAYOUT_SETTING } from '@/setting/layout/post-origination/dialog'
import { SystemEnum } from '@/assets/js'
import { InstantApi, ProcessingApi } from '@/api/pandaria'
import PaymentScheduleTable from '@/components/widget/table/PaymentScheduleTable.vue'
const tool = new Tool()
const popup = new Popup()
export default {
  name: 'PaymentScheduleActionCard',
  components: { PaymentScheduleTable },
  props: {
    value: {
      type: [Object, Array],
      required: true
    },
    setting: {
      type: Object,
      required: true
    },
    items: {
      type: Object
    },
    className: {
      type: String,
      default: ''
    },
    saveAction: {
      type: Function,
      default: null
    },
    hideAction: {
      type: Function,
      default: null
    },
    showTable: {
      type: [Boolean, String],
      default: false
    },
    returnDataType: {
      type: String,
      default: null // 'multiData' || 'singleData'
    },
    operateFunction: {
      type: Function,
      default: null
    },
    loan: Object,
    slaveLoanId: Number,
    disableSaveBtn: {
      type: Boolean,
      default: false
    },
    hasSaveBtn: {
      type: Boolean,
      default: true
    },
    returnCodeArr: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      current: JSON.parse(JSON.stringify(this.value)),
      typeItems: SystemEnum.AUTHORIZATION_TYPE,
      dayOfMonthOptions: [],
      file: null,
      authorizationType: null,
      note: '',
      error: '',
      saveBtn: this.disableSaveBtn,
      tableSetting: PPS_DIALOG_LAYOUT_SETTING.DRAW_CREDIT.PAYMENT_SCHEDULE_TABLE,
      dataType: DataType,
      assist: {
        tool: tool,
        dataType: DataType
      },
      isAllocatePrincipalManuallyShow: false,
      showPaymentScheduleTable: true,
      payOffInNTable: false,
      customizeInstallments: [],
      totalAmount: 0,
      totalPrincipal: 0,
      interestDisplay: false,
      isPrincipalDisplay: false,
      restPrincipal: 0,
      refreshInstallment: [],
      judgeRevokeAch: null,
      isShowRovoked: true
    }
  },
  computed: {
    eleId () {
      return `payment_schedule_action_card_${this._uid}`
    },
    loanId () {
      if (this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
        if (tool.isNotEmpty(this.store.getters.getPPSFirstValidSlaveLoanId)) {
          return this.store.getters.getPPSFirstValidSlaveLoanId
        } else {
          return this.slaveLoanId
        }
      } else if (this.loan.loanType === DataType.LoanTypeEnum.INSTALLMENT_LOAN.value) {
        return this.loan.id
      } else {
        return null
      }
    },
    currentData () {
      let data
      if (this.returnDataType === 'multiData') {
        data = this.multiData
      } else {
        data = this.singleData
      }
      return data
    },
    singleData () {
      let cancelData
      const eventData = {
        changeType: this.setting.value
      }
      const formData = new FormData()
      switch (this.setting.value) {
        case DataType.PaymentScheduleAction.CANCEL_CHANGE.value:
          cancelData = {
            loanId: this.loanId,
            changeType: parseFloat(this.value.changeType),
            installmentId: this.value.id,
            portfolioId: this.value.portfolioId
          }
          return cancelData
        case DataType.PaymentScheduleAction.COLLECTION_SINGLE_CANCEL.value:
          cancelData = {
            installmentId: this.value.id,
            authorizationType: this.authorizationType,
            note: this.note
          }
          return cancelData
        default:
          for (const item of this.setting.fields) {
            eventData[item.fieldKey] = this.current[item.fieldKey]
          }
          if (this.value.transactionStatus === DataType.TransactionStatusEnum.UNKNOWN.value) {
            formData.append('installmentId', this.value.id)
            formData.append('authorizationType', this.authorizationType)
            formData.append('note', this.note)
            formData.append('eventData', JSON.stringify(eventData))
            formData.append('isUnknown', 1)
            if (this.setting.hasFile) {
              formData.append('file', this.file)
            }
          } else {
            formData.append('installmentId', this.value.id)
            formData.append('authorizationType', this.authorizationType)
            formData.append('note', this.note)
            formData.append('eventData', JSON.stringify(eventData))
            if (this.setting.hasFile) {
              formData.append('file', this.file)
            }
          }
          return formData
      }
    },
    multiData () {
      const input = {
        effectiveDate: this.current.effectiveDate,
        changeType: this.setting.value,
        loanId: this.loanId,
        action: DataType.MultiActionRequestEnum.PREVIEW.value
      }
      const inputPayrollFrequency = {
        payrollFrequency: this.current.payrollFrequency,
        firstDayOfMonth: this.current.firstDayOfMonth,
        secondDayOfMonth: this.current.secondDayOfMonth,
        firstDayOfWeek: this.current.firstDayOfWeek
      }
      switch (this.setting.value) {
        case DataType.PaymentScheduleAction.PAY_OFF.value:
          input.transactionMode = this.current.transactionMode
          input.interest = this.current.interest ? this.current.interest : 0
          input.unpaidFee = this.current.unpaidFee ? this.current.unpaidFee : 0
          break
        case DataType.PaymentScheduleAction.PAY_OFF_IN_N.value:
          input.debitCount = parseInt(this.current.debitCount)
          input.financeCharge = this.current.financeCharge ? this.current.financeCharge : 0
          if (this.isAllocatePrincipalManuallyShow) {
            input.customizeInstallments = this.customizeInstallments
          }
          Object.assign(input, inputPayrollFrequency)
          break
        case DataType.PaymentScheduleAction.PAY_DOWN.value:
          input.transactionMode = this.current.transactionMode
          input.extraPrincipal = this.current.extraPrincipal
          break
        case DataType.PaymentScheduleAction.CHANGE_MODE.value:
          input.transactionMode = this.current.transactionMode
          break
        case DataType.PaymentScheduleAction.CHANGE_FREQUENCY.value:
          input.lastPaymentDate = this.current.lastPaymentDate
          Object.assign(input, inputPayrollFrequency)
          break
        case DataType.PaymentScheduleAction.CHANGE_DATE.value:
          input.lastPaymentDate = this.current.lastPaymentDate
          Object.assign(input, inputPayrollFrequency)
          break
        case DataType.PaymentScheduleAction.CHANGE_PAYDAY_ON_HOLIDAY.value:
          input.paydayOnHoliday = this.current.paydayOnHoliday
          break
        case DataType.PaymentScheduleAction.PAY_FIXED_AMOUNT.value:
          input.payFixAmount = this.current.regularAmount
          input.transactionMode = this.current.transactionMode
          input.payrollFrequency = this.current.payrollFrequency
          input.paydayOnHoliday = this.current.paydayOnHoliday
          input.paydayOnAvailable = this.current.paydayOnAvailable
          input.firstDayOfWeek = this.current.firstDayOfWeek
          input.firstDayOfMonth = this.current.firstDayOfMonth
          break
        case DataType.PaymentScheduleAction.CHANGE_PAYDAY_ON_AVAILABLE.value:
          input.paydayOnAvailable = this.current.paydayOnAvailable
          break
        default:
          break
      }
      return input
    }
  },
  created () {
    this.getModifyAmount()
  },
  mounted () {
    if (this.setting.value === DataType.PaymentScheduleAction.REVOKE_WA.value) {
      this.isShowRovoked = false
    }
    if (this.setting.value === DataType.PaymentScheduleAction.CHANGE_MODE.value || this.setting.value === DataType.PaymentScheduleAction.ASSIGNED_MODE.value) {
      ProcessingApi.judgeRevokeAch(this.loanId, (res) => {
        this.judgeRevokeAch = res
      })
    }
    this.$eventBus.$on('updateSaveBtnDisabled', target => {
      this.saveBtn = target
    })
    this.$eventBus.$on('refreshInstallment', target => {
      this.refreshInstallment = target
    })
    this.$eventBus.$on('updateErrorMsg', target => {
      this.error = target
    })
  },
  destroyed () {
    this.$eventBus.$off('updateSaveBtnDisabled')
    this.$eventBus.$off('refreshInstallment')
    this.$eventBus.$off('updateErrorMsg')
  },
  watch: {
    value (val) {
      if (tool.isNotEmpty(val)) {
        this.current = JSON.parse(JSON.stringify(val))
        if (tool.isNotEmpty(this.current.installmentList)) {
          this.colorPaymentScheduleRow(this.current.installmentList)
        }
        if (this.setting.value === DataType.PaymentScheduleAction.PAY_OFF_IN_N.value) {
          if (this.current.financeCharge === 0) {
            this.isAllocatePrincipalManuallyShow = true
            this.getInitialAmount()
          } else {
            this.isAllocatePrincipalManuallyShow = false
            this.payOffInNTable = false
            this.showPaymentScheduleTable = true
          }
        }
      }
    },
    disableSaveBtn (val) {
      this.saveBtn = val
    }
  },
  methods: {
    getCustomizeInstallments () {
      if (this.setting.value === DataType.PaymentScheduleAction.PAY_OFF_IN_N.value) {
        for (let i = 0; i < this.refreshInstallment.length; i++) {
          if (!this.refreshInstallment[i].id) {
            this.customizeInstallments.push(this.refreshInstallment[i])
          }
        }
      }
    },
    getMoreDate () {
      if (this.returnDataType !== 'multiData' && this.current.transactionMode !== DataType.TransactionModeEnum.ACH.value) {
        return ''
      } else {
        return this.store.getters.getFirstCreditDate
      }
    },
    getLessDate () {
      if (this.$route.path.includes('/collection/application/')) {
        return ''
      } else {
        return this.store.getters.getDisbursementDate
      }
    },
    getFieldAllow (field, item) {
      let result = ''
      if (tool.isNotEmpty(item) && tool.isNotEmpty(field)) {
        const fieldKey = field.fieldKey
        const fieldAllowed = field.allowed
        if (tool.isNotEmpty(fieldAllowed)) {
          result = fieldAllowed
        } else if (fieldKey === 'effectiveDate') {
          const transactionMode = item.transactionMode
          if (transactionMode === DataType.TransactionModeEnum.ACH.value) {
            result = 'start-tomorrow no-holiday no-weekend'
          } else {
            result = 'start-now'
          }
        }
      }
      return result
    },
    async checkboxInputChangeEventHandler () {
      this.current.interest = parseFloat(this.current.interest)
      this.current.unpaidFee = parseFloat(this.current.unpaidFee)
      this.returnDataType !== 'multiData' && this.changeEventHandler()
      if (this.operateFunction && this.validate()) {
        let input
        switch (this.setting.value) {
          case DataType.PaymentScheduleAction.PAY_OFF.value:
            input = {
              effectiveDate: this.current.effectiveDate,
              loanId: this.loanId,
              changeType: this.setting.value,
              transactionMode: this.current.transactionMode,
              interest: this.current.interest ? parseFloat(this.current.interest) : 0,
              unpaidFee: this.current.unpaidFee ? parseFloat(this.current.unpaidFee) : 0
            }
            break
          case DataType.PaymentScheduleAction.PAY_OFF_IN_N.value:
            input = {
              effectiveDate: this.current.effectiveDate,
              loanId: this.loanId,
              changeType: this.setting.value,
              transactionMode: this.current.transactionMode,
              financeCharge: this.current.financeCharge ? parseFloat(this.current.financeCharge) : 0,
              debitCount: this.current.debitCount,
              payrollFrequency: this.current.payrollFrequency,
              firstDayOfMonth: this.current.firstDayOfMonth,
              secondDayOfMonth: this.current.secondDayOfMonth,
              firstDayOfWeek: this.current.firstDayOfWeek,
              action: DataType.MultiActionRequestEnum.PREVIEW.value
            }
            break
          default:
            await this.changeEventHandler()
            break
        }
        await this.operateFunction(input, this.setting.value)
      }
    },
    async changeEventHandler (key) {
      if (tool.isNotEmpty(this.current.transactionMode) && this.current.transactionMode === DataType.TransactionModeEnum.ACH.value && this.current.effectiveDate < this.store.getters.getInitEffectiveDate) {
        this.current.effectiveDate = this.store.getters.getInitEffectiveDate
      }
      if (tool.isNotEmpty(this.current.transactionMode) && this.current.transactionMode === DataType.TransactionModeEnum.INSTANT_FUND.value) {
        let hasCard = false
        await InstantApi.getAvailableCard(this.loan.id, function (res) {
          hasCard = tool.isNotEmpty(res) && tool.isNotEmpty(res[0].maskedCardNumber)
        })
        !hasCard && this.$swal({ type: 'warning', text: 'This loan is not bound to the card, you should bind the debit card first !' }).then(
          res => { this.current.transactionMode = DataType.TransactionModeEnum.ACH.value })

        let loanFlag = false
        await ProcessingApi.checkLoanFlag(this.loanId, function () {
          loanFlag = true
        })
        if (this.value.transactionMode !== this.current.transactionMode) {
          if (!loanFlag) {
            popup.popupForWarning('Repayment Mode changed to ACH due to previous rejected payments, are you sure to change repayment mode back to Instant Fund?',
              {
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
              },
              function () {
                ProcessingApi.updateFlag(this.loanId)
              }, function () {
                this.current.transactionMode = DataType.TransactionModeEnum.ACH.value
              })
          }
        }
      }
      this.$validator.validateAll().then(result => {
        const changeType = this.setting.value
        let input
        if (result && this.operateFunction) {
          if (changeType === DataType.PaymentScheduleAction.PAY_OFF.value) {
            // PAY_OFF don't need validate
            input = {
              effectiveDate: this.current.effectiveDate,
              changeType: changeType,
              loanId: this.loanId,
              transactionMode: this.current.transactionMode,
              action: DataType.MultiActionRequestEnum.PREVIEW.value
            }
            this.saveBtn = tool.isNotEmpty(this.error)
            this.operateFunction(input, changeType)
          } else if (changeType === DataType.PaymentScheduleAction.PAY_OFF_IN_N.value) {
            this.current.firstDayOfWeek = new Date(this.current.effectiveDate).getUTCDay() + 1
            input = {
              effectiveDate: this.current.effectiveDate,
              changeType: changeType,
              loanId: this.loanId,
              transactionMode: this.current.transactionMode,
              debitCount: this.current.debitCount,
              payrollFrequency: this.current.payrollFrequency,
              firstDayOfMonth: this.current.firstDayOfMonth,
              secondDayOfMonth: this.current.secondDayOfMonth,
              firstDayOfWeek: this.current.firstDayOfWeek,
              action: DataType.MultiActionRequestEnum.PREVIEW.value
            }
            if (key === 'nextPayrollDate' || key === 'debitCount') {
              if (tool.isNotUndefined(input.financeCharge)) {
                input.debitCount = 2
              }
            }
            this.validate() && this.operateFunction(input, changeType)
          } else if (changeType === DataType.PaymentScheduleAction.PAY_FIXED_AMOUNT.value) {
            input = {
              effectiveDate: this.current.effectiveDate,
              changeType: changeType,
              loanId: this.loanId,
              transactionMode: this.current.transactionMode,
              debitCount: this.current.debitCount,
              payFixAmount: this.current.regularAmount,
              payrollFrequency: this.current.payrollFrequency,
              firstDayOfMonth: this.current.firstDayOfMonth,
              secondDayOfMonth: this.current.secondDayOfMonth,
              firstDayOfWeek: this.current.firstDayOfWeek,
              paydayOnHoliday: this.current.paydayOnHoliday,
              paydayOnAvailable: this.current.paydayOnAvailable,
              action: DataType.MultiActionRequestEnum.PREVIEW.value
            }
            this.validate() && this.operateFunction(input, changeType)
          } else {
            switch (changeType) {
              case DataType.PaymentScheduleAction.CHANGE_FREQUENCY.value:
                this.current.weekDay = new Date(this.current.effectiveDate).getUTCDay() + 1
                break
              case DataType.PaymentScheduleAction.CHANGE_DATE.value:
                this.current.firstDayOfWeek = new Date(this.current.effectiveDate).getUTCDay() + 1
                break
              default:
                break
            }
            input = this.multiData
            this.validate() && this.operateFunction(input, changeType)
          }
        } else if (!result && changeType === DataType.PaymentScheduleAction.CHANGE_FREQUENCY.value) {
          input = this.multiData
          this.validate() && this.operateFunction(input, changeType)
        }
      })
    },
    validate () {
      if (this.setting.limitValue) {
        let newInterest, oldInterest, amount, refundFee, newBankFee, maxPartialAmount, maxPartialBankFee
        let newFinanceFee, oldFinanceFee, newUnpaidFee, oldUnpaidFee, newDebitCount, oldDebitCount, newExtraPrincipal, oldExtraPrincipal
        let newLCSPrincipal, newLCSInterest, newLCSNsfFee, newLCSLateFee, newLCSUnpaidFee
        let maxLCSPrincipal, maxLCSInterest, maxLCSNsfFee, maxLCSLateFee, maxLCSUnpaidFee, maxFinanceCharge, financeCharge
        const numReg = /^(-|\+)?\d+(\.\d+)?$/
        const intReg = /^\d+$/
        switch (this.setting.value) {
          case DataType.PaymentScheduleAction.ASSIGNED_AMOUNT.value:
            if (this.$route.path.includes(DataType.RouterPath.PPS_PATH)) {
              if (this.restPrincipal > 0) {
                if (this.current.principal < 0 || this.current.principal > this.restPrincipal) {
                  this.error = `${this.error} Please enter the principal (0 ~ ${this.restPrincipal}) !`
                }
              } else {
                newInterest = parseFloat(this.current.interest)
                oldInterest = parseFloat(this.store.getters.getPPSSinglePSActionInterest)
                if (numReg.test(this.current.interest.toString()) && (newInterest <= oldInterest && newInterest >= 0)) {
                  this.error = ''
                } else {
                  this.error = `${this.error} Input Correct Interest ! (0 ~ ${oldInterest})`
                }
              }
              newUnpaidFee = parseFloat(this.current.unpaidFee)
              oldUnpaidFee = parseFloat(this.current.maxUnpaidFee)
              if (newUnpaidFee > oldUnpaidFee) {
                this.error = `${this.error} Input Correct Unpaid Fee ! (0 ~ ${oldUnpaidFee})`
              }
            } else if (this.$route.path.includes(DataType.RouterPath.LCS_PATH)) {
              newLCSPrincipal = parseFloat(this.current.principal)
              newLCSInterest = parseFloat(this.current.interest)
              newLCSNsfFee = parseFloat(this.current.nsfFee)
              newLCSLateFee = parseFloat(this.current.lateFee)
              newLCSUnpaidFee = parseFloat(this.current.unpaidFee)
              maxLCSPrincipal = parseFloat(this.current.maxPrincipal)
              maxLCSInterest = parseFloat(this.current.maxInterest)
              maxLCSNsfFee = parseFloat(this.current.maxNsfFee)
              maxLCSLateFee = parseFloat(this.current.maxLateFee)
              maxLCSUnpaidFee = parseFloat(this.current.maxUnpaidFee)
              this.error = ''
              if (!(newLCSPrincipal <= maxLCSPrincipal && newLCSPrincipal >= 0)) {
                this.error = `${this.error} Input Correct Principal (0 ~ ${maxLCSPrincipal}) !`
              }
              if (!(newLCSInterest <= maxLCSInterest && newLCSInterest >= 0)) {
                this.error = `${this.error} Input Correct Interest (0 ~ ${maxLCSInterest}) !`
              }
              if (!(newLCSUnpaidFee <= maxLCSUnpaidFee && newLCSUnpaidFee >= 0)) {
                this.error = `${this.error} Input Correct Unpaid Fee (0 ~ ${maxLCSUnpaidFee}) !`
              }
              if (!(newLCSNsfFee <= maxLCSNsfFee && newLCSNsfFee >= 0)) {
                this.error = `${this.error} Input Correct NSF Fee (0 ~ ${maxLCSNsfFee}) !`
              }
              if (!(newLCSLateFee <= maxLCSLateFee && newLCSLateFee >= 0)) {
                this.error = `${this.error} Input Correct Late Fee (0 ~ ${maxLCSLateFee}) !`
              }
            }
            break
          case DataType.PaymentScheduleAction.REFUND_PAYMENT.value:
            amount = parseFloat(this.current.amount)
            maxPartialBankFee = parseFloat(this.current.maxPartialBankFee)
            refundFee = parseFloat(this.current.refundFee)
            // oldBankFee = parseFloat(this.value.bankFee)
            newBankFee = parseFloat(this.current.bankFee)
            if (refundFee > amount) {
              this.error = `Input Correct Refund Fee ! (0 ~ ${amount})`
            } else if (tool.isNotEmpty(maxPartialBankFee) && (maxPartialBankFee > 50) && (newBankFee > maxPartialBankFee || newBankFee < 0)) {
              this.error = `Input Correct Bank Fee ! (0 ~ ${maxPartialBankFee})`
            } else if (tool.isNotEmpty(maxPartialBankFee) && (maxPartialBankFee < 50) && (newBankFee > 50 || newBankFee < 0)) {
              this.error = `Input Correct Bank Fee ! (0 ~ ${50})`
            } else {
              this.error = ''
            }
            break
          case DataType.PaymentScheduleAction.PAY_OFF.value:
            newFinanceFee = parseFloat(this.current.interest)
            oldFinanceFee = parseFloat(this.current.maxInterest)
            newUnpaidFee = parseFloat(this.current.unpaidFee)
            oldUnpaidFee = parseFloat(this.store.getters.getMultiPayOffUnpaidFee)
            if ((numReg.test(this.current.interest.toString()) && (newFinanceFee <= oldFinanceFee && newFinanceFee >= 0)) &&
            (numReg.test(this.current.unpaidFee.toString()) && (newUnpaidFee <= oldUnpaidFee && newUnpaidFee >= 0))) {
              this.error = ''
            } else if (!numReg.test(this.current.interest.toString()) || newFinanceFee > oldFinanceFee || newFinanceFee < 0) {
              this.error = `Input Correct Finance Charge ! (0 ~ ${oldFinanceFee})`
            } else if (!numReg.test(this.current.unpaidFee.toString()) || newUnpaidFee > oldUnpaidFee || newUnpaidFee < 0) {
              this.error = `Input Correct Unpaid Charge ! (0 ~ ${oldUnpaidFee})`
            }
            break
          case DataType.PaymentScheduleAction.PAY_OFF_IN_N.value:
            newDebitCount = parseFloat(this.current.debitCount)
            oldDebitCount = parseFloat(this.store.getters.getMultiPayOffInNDebitCount)
            financeCharge = parseFloat(this.current.financeCharge)
            maxFinanceCharge = parseFloat(this.store.getters.getMultiPayOffInNMaxFinanceCharge)
            if (this.validatePayrollFrequency() && tool.isNotEmpty(this.current.financeCharge) && tool.isNotEmpty(this.current.debitCount)) {
              if (intReg.test(this.current.debitCount.toString()) && (newDebitCount <= oldDebitCount && newDebitCount >= 2) &&
                (numReg.test(this.current.financeCharge.toString()) && (financeCharge <= maxFinanceCharge && financeCharge >= 0))) {
                this.error = ''
              } else if (!numReg.test(this.current.financeCharge.toString()) || financeCharge > maxFinanceCharge || financeCharge < 0) {
                this.error = `Input Correct Finance Charge ! (0 ~ ${maxFinanceCharge})`
              } else if (newDebitCount > oldDebitCount || newDebitCount < 2) {
                this.error = `Input Correct Pay Off in N ! (must be Integer, 2 ~ ${oldDebitCount})`
              }
            }
            break
          case DataType.PaymentScheduleAction.PAY_DOWN.value:
            newExtraPrincipal = parseFloat(this.current.extraPrincipal)
            oldExtraPrincipal = parseFloat(this.store.getters.getMultiPayDownExtraPrincipal)
            if (numReg.test(this.current.extraPrincipal.toString()) &&
              (newExtraPrincipal <= oldExtraPrincipal && newExtraPrincipal >= 20)) {
              this.error = ''
            } else {
              this.error = `Input Correct Add Pay Down Amount ! (20 ~ ${oldExtraPrincipal})`
            }
            break
          case DataType.PaymentScheduleAction.CHANGE_FREQUENCY.value:
          case DataType.PaymentScheduleAction.CHANGE_DATE.value:
            this.validatePayrollFrequency()
            break
          case DataType.PaymentScheduleAction.ASSIGNED_MAKEUP_PARTIAL.value:
            amount = parseFloat(this.current.amount)
            maxPartialAmount = parseFloat(this.current.maxPartialAmount)
            if (amount < 0 || amount > maxPartialAmount) {
              this.error = `Input Correct Amount ! (0 ~ ${maxPartialAmount})`
            }
            break
          case DataType.PaymentScheduleAction.PAY_FIXED_AMOUNT.value: {
            const maxRegularAmount = parseFloat(this.store.getters.getMultiPayFixAmount)
            if (this.current.regularAmount <= 0) {
              this.error = 'Input Installment Number should be a positive number'
            } else if (this.current.regularAmount > 0 && this.current.regularAmount <= maxRegularAmount) {
              this.error = ''
            } else if (this.current.regularAmount > maxRegularAmount) {
              this.error = `Input Correct Regular Amount ! (0 ~ ${maxRegularAmount})`
            }
            break
          }
          case DataType.PaymentScheduleAction.REVOKE_WA.value:
            if (tool.isNotEmpty(this.authorizationType && this.note)) {
              this.error = ''
            } else {
              if (tool.isEmpty(this.note)) {
                popup.popupForWarning('please fill in note')
                return false
              }
            }
            break
          default:
            break
        }

        if (tool.isNotEmpty(this.error)) {
          this.saveBtn = this.returnDataType === 'multiData'
          return false
        } else {
          this.saveBtn = false
          return true
        }
      } else {
        return true
      }
    },
    validatePayrollFrequency () {
      switch (this.current.payrollFrequency) {
        case DataType.PayrollFrequencyEnum.MONTHLY.value:
          if (!this.current.firstDayOfMonth) {
            this.error = 'Select 1st Monthly Payday'
          } else {
            this.error = ''
          }
          break
        case DataType.PayrollFrequencyEnum.SEMI_MONTHLY.value:
          if (!this.current.firstDayOfMonth || !this.current.secondDayOfMonth) {
            this.error = 'Select 1st Monthly Payday and 2nd Monthly PayDay'
          } else if (this.current.firstDayOfMonth === this.current.secondDayOfMonth) {
            this.error = '1st Monthly Payday and 2nd Monthly PayDay must be different day'
          } else {
            this.error = ''
          }
          break
        case DataType.PayrollFrequencyEnum.WEEKLY.value:
        case DataType.PayrollFrequencyEnum.BI_WEEKLY.value:
          if (!this.current.firstDayOfWeek) {
            this.error = 'Select 1st Day of Week'
          } else {
            this.error = ''
          }
          break
        default:
          break
      }
      return tool.isEmpty(this.error)
    },
    enterAction () {
      const $this = this
      if (this.judgeRevokeAch) {
        if (this.current.transactionMode === DataType.TransactionModeEnum.ACH.value) {
          popup.popupForWarning('Its already marked as Revoke Ach,whether to continue to change to Ach?', {
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
          }, function () {
            $this.save()
          }, function () { return false })
        } else {
          this.save()
        }
      } else {
        this.save()
      }
    },
    save () {
      if (this.validate()) {
        const $this = this
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$validator.validateAll('form').then(res => {
              if ($this.saveAction && res) {
                $this.error = ''
                if (this.setting.value === DataType.PaymentScheduleAction.REVOKE_WA.value) {
                  this.currentData.authorizationType = this.authorizationType
                  this.currentData.note = this.note
                }
                if (this.returnDataType === 'multiData' && this.setting.value !== DataType.PaymentScheduleAction.REVOKE_WA.value) {
                  // if (this.setting.value === DataType.PaymentScheduleAction.PAY_OFF.value || this.setting.value === DataType.PaymentScheduleAction.PAY_OFF_IN_N.value) {
                  //   const newFinanceFee = parseFloat(this.current.interest)
                  //   const oldFinanceFee = parseFloat(this.current.maxInterest)
                  //   const newUnpaidFee = parseFloat(this.current.unpaidFee)
                  //   const oldUnpaidFee = parseFloat(this.store.getters.getMultiPayOffUnpaidFee)
                  //   if (newFinanceFee === oldFinanceFee && newUnpaidFee === oldUnpaidFee) {
                  //     delete this.currentData.interest
                  //     delete this.currentData.unpaidFee
                  //   }
                  // }
                  for (let i = 0; i < this.current.newInstallments.length; i++) {
                    if (!this.current.newInstallments[i].id) {
                      if (Number(this.current.newInstallments[i].principal < 0)) {
                        $this.error = `${this.error} Principal should be a positive number !`
                        return false
                      }
                      this.totalPrincipal += Number(this.current.newInstallments[i].principal)
                    }
                  }
                  if (this.setting.value === DataType.PaymentScheduleAction.PAY_OFF_IN_N.value) {
                    this.getCustomizeInstallments()
                    if (this.isAllocatePrincipalManuallyShow) {
                      if (Number(this.totalAmount.toFixed(2)) !== Number(this.totalPrincipal.toFixed(2))) {
                        $this.error = `${this.error} Please enter the same amount as the original amount !`
                        this.totalPrincipal = 0
                        this.customizeInstallments = []
                        return false
                      }
                    }
                  }
                  this.currentData.action = DataType.MultiActionRequestEnum.SAVE.value
                  this.saveBtn = true
                  this.currentData.authorizationType = this.authorizationType
                  this.currentData.note = this.note
                  this.totalPrincipal = 0
                }
                this.saveAction(this.currentData, this.setting.value)
              } else if (!res) {
                $this.error = 'input completely !'
              }
            })
          } else if (!result) {
            $this.error = 'input correctly !'
          }
        })
      }
    },
    cancelAction () {
      if (this.hideAction) {
        this.hideAction(this.setting.value)
      }
    },
    renderSpanColor (value) {
      if (value > 0) {
        return 'text-green'
      } else if (value < 0) {
        return 'text-red'
      } else if (value === 0) {
        return 'text-blue'
      }
    },
    displayByPayrollFrequency (fieldKey) {
      if (fieldKey !== 'firstDayOfWeek' && fieldKey !== 'firstDayOfMonth' && fieldKey !== 'secondDayOfMonth') {
        return true
      }
      const payrollFrequency = this.current.payrollFrequency
      switch (payrollFrequency) {
        case DataType.PayrollFrequencyEnum.SEMI_MONTHLY.value:
          this.dayOfMonthOptions = DataType.DayOfSemiMonth
          break
        case DataType.PayrollFrequencyEnum.MONTHLY.value:
          this.dayOfMonthOptions = DataType.DayOfMonth
          break
      }
      return tool.displayByPayrollFrequency(fieldKey, payrollFrequency)
    },
    getDateAllowed (field) {
      if (this.returnDataType !== 'multiData' && this.current.transactionMode !== DataType.TransactionModeEnum.ACH.value) {
        return 'start-now'
      }
      return field.allowed
    },
    colorPaymentScheduleRow (installmentsData) {
      for (const installment of installmentsData) {
        const flags = installment.flags
        const changeType = installment.changeType ? parseInt(installment.changeType) : 0
        if (DataType.FlagsEnum.DELETED === (DataType.FlagsEnum.DELETED & flags)) {
          installment.class = 'bg-grey-transparent-1 text-grey'
        } else if (DataType.FlagsEnum.NEW === (DataType.FlagsEnum.NEW & flags)) {
          installment.class = 'bg-blue-transparent-2 text-blue'
          switch (installment.transactionStatus) {
            case DataType.TransactionStatusEnum.NOT_CHECKED.value:
              installment.class = 'bg-orange-transparent-1 text-orange'
              break
            case DataType.TransactionStatusEnum.CHECKED.value:
              if ((installment.flags & DataType.FlagsEnum.FULL_REFUNDED) === DataType.FlagsEnum.FULL_REFUNDED ||
                (installment.flags & DataType.FlagsEnum.PARTIAL_REFUND) === DataType.FlagsEnum.PARTIAL_REFUND) {
                installment.class = 'bg-red-transparent-1 text-red'
              } else {
                installment.class = 'bg-green-transparent-1 text-green'
              }
              break
            case DataType.TransactionStatusEnum.REJECTED.value:
              installment.class = 'bg-red-transparent-1 text-red'
              break
            default:
              switch (changeType) {
                case DataType.ChangeTypeEnum.ASSIGNED_SKIP.value:
                  installment.class = 'bg-red-transparent-1 text-red'
                  break
              }
              break
          }
        } else {
          switch (installment.transactionStatus) {
            case DataType.TransactionStatusEnum.NOT_CHECKED.value:
              installment.class = 'bg-orange-transparent-1 text-orange'
              break
            case DataType.TransactionStatusEnum.CHECKED.value:
              if (installment.flags === DataType.FlagsEnum.FULL_REFUNDED || installment.flags === DataType.FlagsEnum.PARTIAL_REFUND) {
                installment.class = 'bg-red-transparent-1 text-red'
              } else {
                installment.class = 'bg-green-transparent-1 text-green'
              }
              break
            case DataType.TransactionStatusEnum.REJECTED.value:
              installment.class = 'bg-red-transparent-1 text-red'
              break
            default:
              switch (changeType) {
                case DataType.ChangeTypeEnum.ASSIGNED_SKIP.value:
                  installment.class = 'bg-red-transparent-1 text-red'
                  break
              }
              break
          }
        }
      }
    },
    ManuallytableShow () {
      this.payOffInNTable = true
      this.showPaymentScheduleTable = false
    },
    getInitialAmount () {
      this.totalAmount = 0
      if (this.setting.value === DataType.PaymentScheduleAction.PAY_OFF_IN_N.value) {
        for (let i = 0; i < this.current.newInstallments.length; i++) {
          if (!this.current.newInstallments[i].id) {
            this.totalAmount += this.current.newInstallments[i].transactionAmount
          }
        }
      }
    },
    getModifyAmount () {
      if (this.setting.value === DataType.PaymentScheduleAction.ASSIGNED_AMOUNT.value && this.$route.path.includes('/post-origination/application/')) {
        const id = this.current.id
        const $this = this
        $this.interestDisplay = false
        $this.isPrincipalDisplay = false
        ProcessingApi.getPrincipalLimit(id, function (result) {
          if (tool.isNotEmpty(result)) {
            $this.restPrincipal = result
            $this.isPrincipalDisplay = result > 0
            $this.interestDisplay = !$this.isPrincipalDisplay
          }
        },
        function (result) {
          popup.popupForWarning(result.message)
        }
        )
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.error-info {
  border: #d9534f solid 1px;
  border-radius: 5px;
  padding: 5px 10px;
}
</style>
